import React, { useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import Header from "../components/categories/Header";
import { useNavigate } from "react-router-dom";
import CategoryTable from "../components/categories/CategoryTable";
import AddCategoryModal from "../components/categories/AddCategoryModal";
import SubCategoryTable from "../components/categories/SubCategoryTable";
import AddCategoryOptionModal from "../components/categories/AddCategoryOptionModal";
import AgeGroupTable from "../components/categories/AgeGroupTable";
import CourseLevelTable from "../components/categories/CourseLevelTable";

const CourseCategories = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("category");
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);

  const [optionModal, setOptionModal] = useState({
    isOpen: false,
    type: null,
    edit: false,
    item: null,
  });

  const handleAdd = () => {
    switch (activeTab) {
      case "category":
        setIsAddCategoryModalOpen(true);
        break;

      case "subCategory":
      case "ageGroup":
      case "courseLevel":
        setOptionModal({
          isOpen: true,
          type: activeTab,
          edit: false,
          item: null,
        });
        break;

      default:
        break;
    }
  };

  const handleAddOption = (type) => {
    
  setOptionModal({
    isOpen: true,
    type,
    edit: false,
    item: null,
  });
  setIsAddCategoryModalOpen(false)
};

  return (
    <AdminLayout>
      <Header
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onAdd={handleAdd}
        onBack={() => navigate(-1)}
      />
      <div className="mx-auto w-full max-w-[1480px] px-3 py-6 md:px-6">
        {activeTab === "category" && <CategoryTable />}

        {activeTab === "subCategory" && <SubCategoryTable />}

        {activeTab === "ageGroup" && <AgeGroupTable />}

        {activeTab === "courseLevel" && <CourseLevelTable />}
      </div>

      <AddCategoryModal
        isOpen={isAddCategoryModalOpen}
        onClose={() => setIsAddCategoryModalOpen(false)}
        onAddOption={handleAddOption}
      />
      <AddCategoryOptionModal
        isOpen={optionModal.isOpen}
        type={optionModal.type}
        edit={optionModal.edit}
        item={optionModal.item}
        onClose={() =>
          setOptionModal({
            isOpen: false,
            type: null,
            edit: false,
            item: null,
          })
        }
      />
    </AdminLayout>
  );
};

export default CourseCategories;
